import { FormikProps } from 'formik'
import { Button, ButtonIcon, FormInput, FormTextArea } from '../../../../../../../components'
import { IconPaths, IconSize } from '../../../../../../../../_metronic/helpers'
import { FC } from 'react'
import { ResultFormIA } from './ResultadoIAModal'

export type ExameComplementar = {
  exame: string
  instrucoes: string
  id?: number
}

type IExameIAModal = {
  onReset: () => void
  formik: FormikProps<ResultFormIA>
}

// const exameSchema = Yup.object({
//   exame: Yup.string().required('Exame é obrigatório'),
//   instrucoes: Yup.string().required('Instruções é obrigatória'),
// })

export const ExameIAModal: FC<IExameIAModal> = ({ onReset, formik }) => {
  const { values, setFieldValue } = formik
  // const [searchParams] = useSearchParams()
  // const atendimentoId = String(searchParams.get('atendimento'))

  // const createProcedimento = async (index: number) => {
  //   setSubmitting(true)
  //   const currentTouched = Array.isArray(touched.exames_complementares)
  //     ? [...touched.exames_complementares]
  //     : []
  //
  //   currentTouched[index] = {
  //     ...(currentTouched[index] || {}),
  //     exame: true,
  //     instrucoes: true,
  //   }
  //
  //   formik.setTouched({
  //     ...touched,
  //     exames_complementares: currentTouched,
  //   })
  //   try {
  //     const item = values.exames_complementares[index]
  //     await exameSchema.validate(item, { abortEarly: false })
  //
  //     const procedimento: AtendimentoDtoProcedimento = {
  //       id: null,
  //       nome: values.exames_complementares[index].exame,
  //       descricao: values.exames_complementares[index].instrucoes,
  //       data: null,
  //     }
  //     await adicionarProcedimento(Number(atendimentoId), procedimento)
  //     showAlert({
  //       title: 'Sucesso!',
  //       text: 'Procedimento criado com sucesso!',
  //       icon: 'success',
  //     })
  //   } catch (error: any) {
  //     if (error.name === 'ValidationError') {
  //       const fieldErrors = error.inner
  //         .filter((e: Yup.ValidationError) => e.path?.startsWith(`exames_complementares[${index}]`))
  //         .reduce((acc: any, curr: Yup.ValidationError) => {
  //           if (curr.path?.endsWith('exame')) {
  //             acc.exame = curr.message
  //           }
  //           if (curr.path?.endsWith('instrucoes')) {
  //             acc.instrucoes = curr.message
  //           }
  //           return acc
  //         }, {})
  //
  //       if (Object.keys(fieldErrors).length > 0) {
  //         const currentErrors = Array.isArray(formik.errors.exames_complementares)
  //           ? [...formik.errors.exames_complementares]
  //           : []
  //
  //         currentErrors[index] = fieldErrors
  //
  //         formik.setErrors({
  //           ...formik.errors,
  //           exames_complementares: currentErrors as FormikErrors<ExameComplementar>[],
  //         })
  //       }
  //       await Promise.all([
  //         formik.validateField(`exames_complementares.${index}.exame`),
  //         formik.validateField(`exames_complementares.${index}.instrucoes`),
  //       ])
  //     } else {
  //       showError(error)
  //     }
  //   } finally {
  //     setSubmitting(false)
  //   }
  // }

  return (
    <>
      <div className='d-flex align-items-stretch mb-1 w-100' style={{ gap: '0.5rem' }}>
        <div style={{ flex: 2 }} className='d-flex align-items-center'>
          <strong>Exame</strong>
        </div>
        <div style={{ flex: 5 }} className='d-flex align-items-center'>
          <strong>Instruções</strong>
        </div>
        <div
          style={{ width: '32px' }}
          className='d-flex align-items-center justify-content-center'
        />
        {/*  <div
          style={{ width: '110px' }}
          className='d-flex align-items-center justify-content-center'
        /> */}
      </div>
      {values.exames_complementares.map((_, index) => (
        <div
          key={index}
          className='d-flex align-items-stretch mb-3 w-100'
          style={{ gap: '0.5rem' }}
        >
          <div style={{ flex: 2 }}>
            <FormInput
              name={`exames_complementares.${index}.exame`}
              placeholder='Exame'
              formik={formik}
              isDisabled={!!values.exames_complementares[index].id}
            />
          </div>

          <div style={{ flex: 5 }}>
            <FormTextArea
              name={`exames_complementares.${index}.instrucoes`}
              placeholder='Instruções'
              formik={formik}
              rows={1}
            />
          </div>
          <div
            className='d-flex align-items-center justify-content-center'
            style={{ width: '32px' }}
          >
            <ButtonIcon
              color='var(--bs-gray-700)'
              icon={IconPaths.Trash}
              iconSize={IconSize.Small}
              className='m-0 p-0'
              onClick={() => {
                const updatedList = [...values.exames_complementares]
                updatedList.splice(index, 1)
                setFieldValue('exames_complementares', updatedList)
                onReset()
              }}
            />
          </div>
          {/*   <div
            style={{ width: '110px' }}
            className='d-flex align-items-center justify-content-center'
          >
            <Button
              className='btn-sm btn-primary align-items-center'
              onClick={() => createProcedimento(index)}
              disabled={formik.isSubmitting}
            >
              Criar Exame
            </Button>
          </div> */}
        </div>
      ))}
      <div className='d-flex justify-content-end'>
        <Button
          className='btn-sm btn-primary mt-3'
          icon={IconPaths.Add}
          onClick={() => {
            setFieldValue('exames_complementares', [
              ...values.exames_complementares,
              { exame: '', instrucoes: '' },
            ])
            onReset()
          }}
        >
          Adicionar Exame
        </Button>
      </div>
    </>
  )
}
